<script>
    import { localeState, setAppLocale } from "@app/store/localeStore.svelte.js";
    import * as m from "@app/paraglide/messages.js";

    /** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
    let { currentState, toggleMenu } = $props();

    function handleToggleMenu() {
        toggleMenu("language");
    }

    function selectLocale(lang) {
        setAppLocale(lang);
        handleToggleMenu();
    }
</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
    <a onclick={handleToggleMenu} class="dropdown-toggle nav-link" href="#!/" id="languageMenu" aria-haspopup="true" aria-expanded={currentState} aria-label={m.language_selection()}>{localeState.current.toUpperCase()}</a>
    <div class="dropdown-menu {currentState ? 'show' : ''}" aria-labelledby="languageMenu" role="menu">
        <a class="dropdown-item {localeState.current === 'en' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('en')} role="menuitem" id="langEnBtn">{m.english()}</a>
        <a class="dropdown-item {localeState.current === 'fr' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('fr')} role="menuitem" id="langFrBtn">{m.french()}</a>
        <a class="dropdown-item {localeState.current === 'de' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('de')} role="menuitem" id="langDeBtn">{m.german()}</a>
        <a class="dropdown-item {localeState.current === 'it' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('it')} role="menuitem" id="langItBtn">Italiano</a>
        <a class="dropdown-item {localeState.current === 'ru' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('ru')} role="menuitem" id="langRuBtn">Русский</a>
        <a class="dropdown-item {localeState.current === 'es' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('es')} role="menuitem" id="langEsBtn">Español</a>
        <a class="dropdown-item {localeState.current === 'zh-CN' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('zh-CN')} role="menuitem" id="langZhCnBtn">简体中文</a>
        <a class="dropdown-item {localeState.current === 'ja' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('ja')} role="menuitem" id="langJaBtn">日本語</a>
        <a class="dropdown-item {localeState.current === 'hi' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('hi')} role="menuitem" id="langHiBtn">हिन्दी</a>
        <a class="dropdown-item {localeState.current === 'pt-PT' ? 'active' : ''}" href="#!/" onclick={() => selectLocale('pt-PT')} role="menuitem" id="langPtPtBtn">Português (Portugal)</a>
    </div>
</li>
